import IOperatingLeaseSettings from "@/module/main/dto/IOperatingLeaseSettings";
import IInstallmentScheduleParameter from "@/module/main/dto/IInstallmentScheduleParameter";

export default class OperatingLeaseSettings implements IOperatingLeaseSettings
{
    constructor(
        public productCode: string,
        public installmentScheduleParameters: IInstallmentScheduleParameter[],
    )
    {
    }
}
